import React from "react";
import { AiOutlineDownload } from "react-icons/ai";
import resumeLink from "../Assets/CV_aw.pdf";

function Resume() {
  return (
    <section id="resume" className="py-24 px-6">
      <div className="fade-section max-w-3xl mx-auto text-center">
        <h2 className="text-sm font-medium text-accent uppercase tracking-widest mb-4">
          Resume
        </h2>
        <h3 className="text-3xl md:text-4xl font-bold text-white mb-6">
          My CV
        </h3>
        <p className="text-neutral-400 mb-8">
          Download my resume to learn more about my experience and background.
        </p>
        <a
          href={resumeLink}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-6 py-3 bg-accent text-white text-sm rounded-lg hover:bg-accent-light transition-colors"
        >
          <AiOutlineDownload className="text-lg" />
          Download CV
        </a>
      </div>
    </section>
  );
}

export default Resume;
